/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Impersonation/Impersonation',[
    'jquery',
    'global/all',
    './Impersonation.Service',
    './Impersonation.Forms',
    'plugins/jquery.debouncedresize'
], function ($, Roc, ImpersonationService, Forms) {
    'use strict';

    var userInfo;

    var btns = {
        // search cart button in toolbar
        openCartSearch: '[data-roc-action="openCartSearch"]',
        // search button within cart modal
        cartSearch: '[data-roc-action="cartSearch"]',
        // search input for cart search
        cartSearchInput: '#roc-impersonation-cart-filter',
        // impersonate cart button in search results
        impersonateCart: '[data-roc-action="impersonateCart"]',
        // impersonate cart button in search results (for saved carts)
        impersonateSavedCart: '[data-roc-action="impersonateSavedCart"]',

        // login as customer button in toolbar
        openCustomerSearch: '[data-roc-action="openCustomerSearch"]',
        // search button within customer modal
        customerSearch: '[data-roc-action="customerSearch"]',
        // search input for customer search
        customerSearchInput: '#roc-impersonation-customer-filter',
        // impersonate customer button in search results
        impersonateCustomer: '[data-roc-action="impersonateCustomer"]',

        backToAdmin: '[data-roc-action="backToAdmin"]',
        // stop impersonating button in toolbar
        stopImpersonating: '[data-roc-action="stopImpersonating"]',
        // impersonate a guest button in the customer search modal
        impersonateGuest: '[data-roc-action="impersonateGuest"]'
    };


    /* Cart Search  */

    var paginationCarts;

    function loadCartList() {
        var request = paginationCarts; // load filters and pagination details
        ImpersonationService
            .searchCarts(request)
            .done(function (resp) {
                resp.pagination = Roc.Pagination.updatePaging(resp);
                Roc.UI.template('#impShoppingCartList-Tmp', resp).then(function (renderedTemplate) {
                    $('[data-roc-wrapper="cartList"]').html(renderedTemplate);
                    Roc.Core.releaseLockedButton(btns.cartSearch);
                });
                paginationCarts = resp.pagination;
            }).fail(function (xhr) {
                Roc.Logger.error(xhr);
                Roc.UI.ajaxErrorPopup(xhr);
                Roc.Core.releaseLockedButton(btns.cartSearch);
            });
    }
    function updateCartListFilters(pg, reload) {
        if (typeof pg != 'undefined') {
            paginationCarts = pg;
        }
        if (reload) {
            loadCartList();
        }
    }
    function displayCartSearchPopup() {
        Roc.UI.template('#impShoppingCartSearch-Tmp').then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate);
            paginationCarts = Roc.Pagination.init({
                page: 1,
                pageSize: 3,
                prefix: '[data-roc-wrapper="cartSearch"]',
                // by default we order by CreateDate, so use descending sort order
                sortType: Roc.Enums.pagination.Descending,
            }, updateCartListFilters);
        });
    }
    function performCartSearch() {
        var isValid = Roc.Validation.validateForm(Forms.cartSearch);
        if (isValid) {
            Roc.Core.lockButton(btns.cartSearch);
            loadCartList();
        }
    }

    function openCartSearchEvent() {
        $(document)
            .off('click', btns.openCartSearch)
            .on('click', btns.openCartSearch, displayCartSearchPopup);
    }
    function cartSearchEvent() {
        $(document)
            .off('click', btns.cartSearch)
            .on('click', btns.cartSearch, performCartSearch);
        $(document)
            .off('keyup', btns.cartSearchInput)
            .on('keyup', btns.cartSearchInput, function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    performCartSearch();
                }
            });
    }
    function impersonateCartEvent() {
        $(document)
            .off('click', btns.impersonateCart)
            .on('click', btns.impersonateCart, function (e) {
                var cartButton = $(e.currentTarget);

                var cartId = $(this).closest('[data-roc-cartid]').attr('data-roc-cartid');
                var sessionId = $(this).closest('[data-roc-sessionid]').attr('data-roc-sessionid');

                Roc.Core.lockButton(cartButton);

                ImpersonationService.impersonateCart(cartId, sessionId);
            });
    }
    function impersonateSavedCartEvent() {
        $(document)
            .off('click', btns.impersonateSavedCart)
            .on('click', btns.impersonateSavedCart, function (e) {
                var cartButton = $(e.currentTarget);

                var cartId = $(this).closest('[data-roc-cartid]').attr('data-roc-cartid');
                var sessionId = $(this).closest('[data-roc-sessionid]').attr('data-roc-sessionid');

                Roc.Core.lockButton(cartButton);

                ImpersonationService.impersonateCart(cartId, sessionId, true);
            });
    }


    /* Customer Search  */

    var paginationCustomers;

    function loadCustomerList() {
        var request = paginationCustomers; // load filters and pagination details

        ImpersonationService
            .searchCustomers(request)
            .done(function (resp) {
                resp.pagination = Roc.Pagination.updatePaging(resp);
                Roc.UI.template('#impCustomerList-Tmp', resp).then(function (renderedTemplate) {
                    $('[data-roc-wrapper="customerList"]').html(renderedTemplate);
                    Roc.Core.releaseLockedButton(btns.customerSearch);
                });
                paginationCustomers = resp.pagination;
            }).fail(function (xhr) {
                Roc.Logger.error(xhr);
                Roc.UI.ajaxErrorPopup(xhr);
                Roc.Core.releaseLockedButton(btns.customerSearch);
            });
    }
    function updateCustomerListFilters(pg, reload) {
        if (typeof pg != 'undefined') {
            paginationCustomers = pg;
        }

        if (reload) {
            loadCustomerList();
        }
    }
    function displayCustomerSearchPopup() {
        Roc.UI.template('#impCustomerSearch-Tmp', userInfo).then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate);
            paginationCustomers = Roc.Pagination.init({
                page: 1,
                pageSize: 3,
                prefix: '[data-roc-wrapper="customerSearch"]',
                // by default we order by CreateDate, so use descending sort order
                sortType: Roc.Enums.pagination.Descending,
            }, updateCustomerListFilters);
        });
    }
    function performCustomerSearch() {
        var isValid = Roc.Validation.validateForm(Forms.customerSearch);
        if (isValid) {
            Roc.Core.lockButton(btns.customerSearch);
            loadCustomerList();
        }
    }

    function openCustomerSearchEvent() {
        $(document)
            .off('click', btns.openCustomerSearch)
            .on('click', btns.openCustomerSearch, function () {
                displayCustomerSearchPopup();
            });
    }
    function customerSearchEvent() {
        $(document)
            .off('click', btns.customerSearch)
            .on('click', btns.customerSearch, performCustomerSearch);
        $(document)
            .off('keyup', btns.customerSearchInput)
            .on('keyup', btns.customerSearchInput, function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    performCustomerSearch();
                }
            });
    }
    function impersonateCustomerEvent() {
        $(document)
            .off('click', btns.impersonateCustomer)
            .on('click', btns.impersonateCustomer, function () {
                var sessionId = $(this).closest('[data-roc-sessionid]').attr('data-roc-sessionid');
                if (sessionId) {
                    ImpersonationService.impersonateUser(sessionId);
                }
            });
    }


    /* Toolbar  */

    function backToAdminEvent() {
        $(document)
            .off('click', btns.backToAdmin)
            .on('click', btns.backToAdmin, function () {
                window.location.href = '/Sitefinity/Roc';
            });
    }
    function stopImpersonatingEvent() {
        $(document)
            .off('click', btns.stopImpersonating)
            .on('click', btns.stopImpersonating, function () {
                ImpersonationService.stopImpersonating()
                    .then(function () {
                        window.location.href = '/';
                    });
            });
    }
    function impersonateGuestEvent() {
        $(document)
            .off('click', btns.impersonateGuest)
            .on('click', btns.impersonateGuest, function () {
                ImpersonationService.impersonateGuest();
            });
    }

    function compensateForToolbarSize(toolbar) {
        var toolbarHeight = $(toolbar).outerHeight();

        if (window.matchMedia("(max-width: 939px)").matches) {
            var $stickyNav = $('#sticky-nav');

            $stickyNav.css('top', toolbarHeight);
            $('.roc-toolbar-enabled').css('padding-top', toolbarHeight + $stickyNav.outerHeight(true));
        } else {
            $('.roc-toolbar-enabled').css('padding-top', toolbarHeight);
        }
    }

    function bindEvents() {
        // bind cart events
        openCartSearchEvent();
        cartSearchEvent();
        impersonateCartEvent();
        impersonateSavedCartEvent();
        // bind customer events
        openCustomerSearchEvent();
        customerSearchEvent();
        impersonateCustomerEvent();
        // bind toolbar events
        backToAdminEvent();
        stopImpersonatingEvent();
        impersonateGuestEvent();
    }

    function init() {
        // add padding to body so that the toolbar is above it
        $('body').addClass('roc-toolbar-enabled').attr('data-roc-action', 'impersonation');



        ImpersonationService
            .loadUserInfo()
            .done(function (resp) {
                userInfo = resp;
                Roc.UI.template('#impToolBar-Tmp', resp).then(function (renderedTemplate) {
                    $('[data-roc-wrapper="impToolBar"]').html(renderedTemplate);
                    bindEvents();
                    compensateForToolbarSize('[data-roc-action="impersonationToolbar"]');
                });

                $(window).on("debouncedresize", function (event) {
                    compensateForToolbarSize('[data-roc-action="impersonationToolbar"]');
                });
            }).fail(function (xhr) {
                Roc.Logger.error(xhr);
            });
    }

    var Impersonation = {
        init: init
    };

    Roc.Logger.debug('Impersonation.js Loaded:', Impersonation);
    return Impersonation;
});
